<template>
    <v-dialog v-model="dialog" max-width="700px" persistent scrollable>
        <v-card class="booking-dialog-card">
            <div class="booking-dialog-header pa-5">
                <div class="d-flex align-center justify-space-between">
                    <div class="booking-dialog-title">
                        <v-icon class="mr-2" color="white" size="20">mdi-email-send-outline</v-icon>
                        Send Organiser Balance Due Reminder
                    </div>
                    <v-btn icon dark @click="closeDialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
            </div>
            <v-card-text class="pa-6">
                <div class="booking-section mb-4">
                    <div class="booking-section-header mb-1">
                        <v-icon size="14" color="#3988AA" class="mr-1">mdi-format-title</v-icon>
                        SUBJECT
                    </div>
                    <v-text-field v-model="subject" outlined dense placeholder="Enter email subject"
                        hide-details></v-text-field>
                </div>
                <div class="booking-section">
                    <div class="booking-section-header mb-2">
                        <v-icon size="14" color="#3988AA" class="mr-1">mdi-text</v-icon>
                        EMAIL CONTENT
                    </div>
                    <wysiwyg v-model="body" placeholder="Compose the balance due reminder email..." />
                </div>
            </v-card-text>
            <v-divider />
            <v-card-actions class="pa-4 custom-buttons">
                <v-spacer></v-spacer>
                <v-btn text @click="closeDialog()">Cancel</v-btn>
                <v-btn dark color="#3988AA" :loading="sending" :disabled="!subject || !body" @click="sendEmail()">
                    <v-icon small left>mdi-send</v-icon>
                    Send
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from "vuex"

export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        lead: {
            type: Object,
            default: () => ({})
        },
        event: {
            type: Object,
            default: () => ({})
        },
        company_id: {
            type: Number,
            default: null
        }
    },
    data: () => ({
        subject: '',
        body: '',
        sending: false,
    }),
    computed: {
        ...mapGetters({
            get_user: 'auth/get_user',
        }),
        dialog: {
            get() {
                return this.show
            },
            set(val) {
                if (!val) this.closeDialog()
            }
        }
    },
    mounted() {
        if (this.show) {
            this.subject = this.buildDefaultSubject()
            this.body = this.buildDefaultBody()
        }
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.sending = false
                this.subject = this.buildDefaultSubject()
                this.body = this.buildDefaultBody()
            }
        }
    },
    methods: {
        closeDialog() {
            this.$emit('close')
        },
        buildDefaultSubject() {
            return `Balance due for ${this.event?.name || ''}`
        },
        buildDefaultBody() {
            const lead = this.lead || {}
            const event = this.event || {}
            const advisorName = this.get_user?.name || ''
            const companyNumber = event.company?.number || ''
            const payDate = event.pay_date ? this.$date(event.pay_date).format('DD/MM/YYYY') : ''

            return `
                <div style="text-align:center;font-size:28px;color:black;"><b>Hello ${lead.first_name || ''},</b></div>
                <br>
                <p style="text-align:left;color:black;font-size:16px;">
                    ${advisorName} here.
                    <br><br>
                    Your group's balance is due on <b>${payDate}</b>.
                    <br><br>
                    Please review your attendee list and remove anyone who will not be attending. Please note that some activities require minimum numbers, and minimum accommodation nights apply in certain locations.
                    <br><br>
                    You can pay online now, or call us on ${companyNumber} (option 2) during office hours (Mon - Fri 9am - 5:30pm).
                    <br><br>
                    <b>Once you have paid:</b> within 7 days of receiving your balance payment, we will send your itinerary by email. It will also be available online for you to view and share with your invitees.
                    <br><br>
                    It's still not too late to add accommodation to your booking. Just call me for a quote.
                </p>
            `
        },
        async sendEmail() {
            this.sending = true
            try {
                const payload = {
                    company_id: this.company_id,
                    lead: this.lead,
                    event: this.event,
                    subject: this.subject,
                    body: this.body,
                    email_type: 'organiser_balance_due',
                }
                const result = await (await this.$axios.post('admin/events/send_organiser_email', payload)).data
                if (result.response == true) {
                    this.$toast.success(result.message)
                    this.closeDialog()
                } else {
                    this.$toast.error('Failed to send balance due reminder email')
                }
            } catch (error) {
                this.$toast.error('Failed to send balance due reminder email')
            } finally {
                this.sending = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.booking-dialog-header {
    background: linear-gradient(135deg, #3988AA 0%, #2a6a88 100%);
}

.booking-dialog-title {
    font-family: Manrope;
    font-size: 16px;
    font-weight: 700;
    color: white;
    display: flex;
    align-items: center;
}

.booking-section-header {
    font-family: Manrope;
    font-size: 12px;
    font-weight: 700;
    color: #3D3D3D;
    display: flex;
    align-items: center;
}
</style>
